import {ReactElement, ReactNode} from 'react';

const convertNodeToElement = (node: ReactNode): ReactElement | null => {
	if (node === undefined) return null;

	// eslint-disable-next-line react/jsx-no-useless-fragment
	return <>{node}</>;
};

type WithChildren = {
	children?: ReactNode;
};

export {type WithChildren, convertNodeToElement};
